import { useMediaQuery } from '@mantine/hooks';

/**
 * Hook to detect device type and screen size
 *
 * Breakpoints:
 * - Mobile: < 768px
 * - Tablet: 768px - 1200px
 * - Desktop: > 1200px
 *
 * @returns Object with device type flags and current device type
 */
export const useResponsive = () => {
  const isMobile = useMediaQuery('(max-width: 768px)');
  const isTablet = useMediaQuery('(min-width: 768px) and (max-width: 1200px)');
  const isDesktop = useMediaQuery('(min-width: 1200px)');
  const isTouchDevice = typeof window !== 'undefined' && 'ontouchstart' in window;

  // Determine device type (useful for single checks)
  const getDeviceType = (): 'mobile' | 'tablet' | 'desktop' => {
    if (isMobile) return 'mobile';
    if (isTablet) return 'tablet';
    return 'desktop';
  };

  return {
    isMobile,
    isTablet,
    isDesktop,
    isTouchDevice,
    deviceType: getDeviceType(),
  };
};
